

<mat-dialog-content class="dialog-container" [ngStyle]="{'background-color': couleur}">

  <img [src]="logoPath" class="logo"/>

  <div style="margin: 2rem; text-align: justify;"> 
    <p>{{ question }} </p>

  </div>


    <div class="dialog-action">

    <button class="btn btn-rounded btn-company mx-1 hide-lg" [ngClass]="{ 'btn-vitafrais': otherCompanyIsVitafrais, 'btn-pronatura': !otherCompanyIsVitafrais }" (click)="closeDialog()">
          {{'distributionList.subscribedNo' | translate }}
    </button>
      
      
    <button mat-button
      [mat-dialog-close]="true" class="btn btn-rounded btn-highlight mx-1 hide-l">
      {{ 'distributionList.CompleteYes' | translate }}  {{data.otherCompany}}
    </button>
      

    </div>

  </mat-dialog-content>
